import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 gap-4 w-full" }
const _hoisted_2 = { class: "flex justify-end" }
const _hoisted_3 = { class: "text-center" }

import {BryntumGrid} from "@bryntum/grid-vue-3";
import GridInputFilter from "@/components/GridInputFilter";
import {onMounted, reactive, ref} from "vue";
import {useGlobalStore} from "@/stores/GlobalStore";
import ErrorHandler from "@/utilities/helpers/ErrorHandler";
import {DisdiStateType, ErrorLocationType, PopupType, TableType} from "@/utilities/enums/Enums";
import {Store, StringHelper} from "@bryntum/grid";
import LoadingSpinner from "@/components/LoadingSpinner";
import isNullOrUndefined from "@/utilities/helpers/NullOrUndefinedHelper";
import {useI18n} from "vue-i18n";
import DateToStringHelper from "@/utilities/helpers/DateToStringHelper";
import dialog from "@/dialog";
import {RegistrationService} from "@/utilities/services/entities/RegistrationService";
import {RegisteredUserInfo} from "@/models/registration/RegisteredUserInfo";
import {PermissionService} from "@/utilities/services/PermissionService";
import router from "@/router";
import {LocationRegistrationInfo} from "@/models/registration/LocationRegistrationInfo";



export default /*@__PURE__*/_defineComponent({
  __name: 'LocationReportsUserHistoryPopup',
  setup(__props) {

const globalStore = useGlobalStore();
const { t } = useI18n();
const registrationService = new RegistrationService();
const permissionService = new PermissionService();


const userList = ref([]);
const loading = ref(true);
const selectedLocation = ref<LocationRegistrationInfo|null>(null);
const gridStore = new Store();

const grid = ref(null);
const useGridConfig = {
  autoHeight : true,
  headerMenuFeature: false,
  cellTooltipFeature: {
    hoverDelay      : 300,
    textContent     : true,
    hideOnDelegateChange: true,
  },
  columns : {
    data: [
      {
        id: 'isActive',
        field: 'isActive',
        text: "",
        width: 36,
        minWidth: 36,
        type: "template",
        template: ({ record }) => {
          return record.data.isActive
              ? `<div class="userActivity isActive"></div>`
              : `<div class="userActivity"></div>`;
        },
      },
      {
        id: 'firstName',
        field: "firstName",
        text: t("popups.registrationReports.grid.firstName"),
        flex:2,
        type: 'template',
        template:({record})=>{
					if(record.data.isCoupled) {
						return t("registrationReports.grid.coupledUser");
					} else {
						return StringHelper.xss`${record.data.firstName ?? ""}, ${record.data.lastName ?? ""}`;
					}

        }
      },
      {
        id: 'infoButton',
        field: 'infoButton',
        text: t('registrationReports.grid.info'),
        width: 36,
        type: "template",
        template: ({record}) => {
					if(!record.data.isCoupled) {
						return `<div class='gridRowButton'><span class='icon-info'></span></div>`;
					}
        },
      },
      {
        id: 'companyName',
        field: "companyName",
        text: t("popups.registrationReports.grid.company"),
        flex:1,
        type: "template",
        template: ({record}:any)=>{
          if(isNullOrUndefined(record.data.companyName)) record.data.companyName = globalStore.settings.systemCompanySettings?.companyName;
					return StringHelper.xss`${record.data.companyName ?? ""}`;
        },
      },
      {
        id: 'registeredDate',
        field: "registeredDate",
        text: t("popups.registrationReports.grid.registerUnregister"),
        flex:2,
        type: "template",
        template: ({record})=>{
          const reg = record.data.registeredDate === null
              ? ""
              : DateToStringHelper(new Date(record.data.registeredDate));
          return `${reg}`;
        },
      },
      {
        id: 'unregisteredDate',
        field: "unregisteredDate",
        text: t("popups.registrationReports.grid.unregister"),
        flex:2,
        type: "template",
        template: ({record})=>{
          const unreg = record.data.unregisteredDate === null
              ? ""
              : DateToStringHelper(new Date(record.data.unregisteredDate));
          return `${unreg}`;
        },
      },
      {
        id: 'activityText',
        field: 'activityText',
        text: '',
        hidden: !globalStore.settings.activitySettings?.activitesEnabled,
        minWidth: 36,
        maxWidth: 56,
        type: "template",
        tooltipRenderer : ({ record }) => isNullOrUndefined(record.data.activityText) ? "" : StringHelper.xss`<b>${t('registrationReports.grid.activity')}</b><br/>${record.data.activityText ?? ""}<br/>`,
        template: ({record}) => {
          return isNullOrUndefined(record.data.activityText)
              ? ""
              : `<div class='gridTooltipButton'><span class='icon-activity'></span></div>`;
        },
      },
      {
        id:'hasDisdi',
        field:'hasDisdi',
        text	: "",
        width   : 36,
        type	: 'template',
        align: "center",
        hidden: !permissionService.userHasPermission("Disdi.Read"),
        resizable: false,
        filterable: false,
        template : ({record}:any)=> {
          return selectedLocation.value.hasDisdi && record.data.disdiCount > 0
              ? `<div class='gridRowButton'><span class='icon-liste_tagebuch'></span></div>`
              : selectedLocation.value.hasDisdi && record.data.disdiCount === 0
                  ? `<div class='gridRowButtonDisabled'><span class='icon-liste_tagebuch'></span></div>`
                  : "";
        }
      },
      {
        id: 'unregister',
        field : 'unregister',
        text: "",
        minWidth: 36,
        maxWidth: 56,
        type: "template",
        template: ({record}) => {
					if(!record.data.isCoupled) {
						return record.data.unregisteredDate === null ? `<div class='gridRowButton'><span class='icon-abmelden'></span></div>` : "";
					}
        },
      },
    ],
    listeners:{
      async add(event:any){
        if(event.records.length === 1 && event.isMove[event.records[0].id]){
          await globalStore.saveUserColumnOrder(TableType[TableType.locationReportsUserHistory], event.records[0].id, event.index.toString());
        }
      },
    }
  },
  store: gridStore,
  enableTextSelection: true,
  listeners: {
    async cellClick({column, record}) {
      if (column.data.field === 'unregister') {
        if(record.data.unregisteredDate !== null) return;

        const answer = await dialog
            .okText(t("global.unregister"))
            .cancelText(t("global.cancel"))
            .confirm(t("registrationReports.confirmUnregister", { name: `${record.data.firstName} ${record.data.lastName}`, location:selectedLocation.value.name}));

        if (answer){
          const unregResp = await registrationService.postUnRegisterUser(record.data.userId, selectedLocation.value.id);
          if(unregResp === null || unregResp === undefined || unregResp?.statusCode !== 0){
            ErrorHandler.handleError(unregResp, ErrorLocationType.table);
            return;
          }

          record.data.unregisteredDate = new Date().toJSON();

          gridStore.add(record.data);
        }
      }
      if(column.data.field === 'infoButton') {
				// Open Popup only for "normal" users, not coupled
				if(!record.data.isCoupled) {
					const backLocation = selectedLocation.value;
					const convertedUserData = await convertToRegistrationReport(record.data);
					const payload = {backLocation:backLocation, userData:convertedUserData};

					globalStore.openPopup({
						data: payload,
						action: globalStore.closeModal,
						title: t('registrationReports.userDetailPopupTitle'),
						type: PopupType.registrationUserHistory
					}, true);
				}
      }

      if(column.data.field === "hasDisdi"){
        if (selectedLocation.value?.hasDisdi && record.data.disdiCount > 0){
          await router.push(`disdi/${TableType[TableType.register]}/${+record.data.registrationId}`)
        }
      }
    },
  }
}
const gridConfig = reactive(useGridConfig);

const convertToRegistrationReport = async (userData:any) => {
  const data = userData as RegisteredUserInfo;
  data.fullName = `${data.firstName} ${data.lastName}`;

  return data;
}

const setDisdiColumVisibility = async() =>{
  const disdiIsOn = globalStore.settings.disdiSettings?.disdi !== DisdiStateType.NoDISDI;

  if(!disdiIsOn){
    const hasDisdiCol = grid.value.instance.value.columns.getById("hasDisdi");
    hasDisdiCol.hidden = true;
  }
}

onMounted(async ()=>{
  loading.value = true;

  selectedLocation.value = globalStore.modal.contentObject;

  const userHistoryReps = await registrationService.getUserInfoForLocation(selectedLocation.value.id);
  if (userHistoryReps === null || userHistoryReps === undefined || userHistoryReps.statusCode !== 0) {
    ErrorHandler.handleError(userHistoryReps, ErrorLocationType.popup);

    loading.value = false;

    return;
  }

  userList.value = userHistoryReps.locationInfo?.map(h => {
    h.isActive = h.unregisteredDate === null;
    return h;
  });

  loading.value = false;

  gridStore.setStoreData(userList.value);

  await setDisdiColumVisibility();

  try {
    globalStore.reorderColumns(TableType[TableType.locationReportsUserHistory], grid.value.instance.value.columns);
  }
  catch (e) {
    console.log(e)
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(GridInputFilter), {
          gridStore: _unref(gridStore),
          hideFilterButton: true
        }, null, 8, ["gridStore"])
      ]),
      _createVNode(_unref(BryntumGrid), _mergeProps({
        ref_key: "grid",
        ref: grid
      }, gridConfig, { readOnly: true }), null, 16)
    ], 512), [
      [_vShow, !loading.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(LoadingSpinner))
    ], 512), [
      [_vShow, loading.value]
    ])
  ]))
}
}

})